import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceResponse } from '../models/service-response';
import { Observable } from 'rxjs';
import { urlServer } from '../global_constants';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  listUrl = urlServer.concat('/v1/classes')

  public get token() : string|null {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
    return localStorage.getItem("token");
    return sessionStorage.getItem("token");
  }
  
  constructor(private http: HttpClient) { }

  getClasses(): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.http.get<ServiceResponse>(this.listUrl,{headers: header});
  }
}
